import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { RecoilRoot } from "recoil";
import { CssBaseline } from "@mui/material";

import { App } from "./App";
import { I18nProvider } from "./shared/providers/I18nProvider";
import { AuthProvider } from "./shared/providers/AuthProvider";
import { ColorModeProvider } from "./shared/providers/ColorModeProvider";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <RecoilRoot>
      <I18nProvider>
        <ColorModeProvider>
          <CssBaseline />
          <BrowserRouter>
            <AuthProvider>
              <App />
            </AuthProvider>
          </BrowserRouter>
        </ColorModeProvider>
      </I18nProvider>
    </RecoilRoot>
  </React.StrictMode>,
);
